import { Injectable } from '@angular/core';
import { NUMBER_0, NUMBER_10 } from '~shared/constants';
import { NavigationHelper } from '~shared/services/navigation-helper.service';

interface TrackedScrollItem {
  page: number;
  index: number;
  currentURL: string;
}

@Injectable({
  providedIn: 'root',
})
export class ListviewReporterService {
  private trackedScroll: TrackedScrollItem[] = [];

  constructor(private navigationHelper: NavigationHelper) {}

  public trackListView(index: number, currentPage: number): boolean {
    const currentURL: string = this.navigationHelper.getCurrentUrl();
    let shouldTrackListView: boolean = false;
    const isIndexPower10: boolean = index % NUMBER_10 === NUMBER_0;
    if (isIndexPower10) {
      const wasAlreadyTracked: boolean = !!this.trackedScroll.find(
        (trackedScrollItem) =>
          trackedScrollItem.page === currentPage &&
          trackedScrollItem.index === index &&
          trackedScrollItem.currentURL === currentURL
      );

      if (!wasAlreadyTracked) {
        this.trackedScroll.push({
          page: currentPage,
          index: index,
          currentURL: currentURL,
        });

        shouldTrackListView = true;
      }
    }

    return shouldTrackListView;
  }
}
